import styled from "styled-components";

export const WorkspaceContextSelectorsRow = styled.div`
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  min-width: 0;
  width: 100%;
`;

export const SchoolSelectorField = styled.div`
  display: flex;
  min-width: 0;
  width: 100%;

  @media (min-width: 640px) {
    max-width: 24rem;
  }
`;

export const SchoolSelectorControl = styled.div<{ $compact?: boolean }>`
  align-items: center;
  background: rgba(10, 13, 18, 0.72);
  border: 1px solid var(--brand-border);
  border-radius: 1rem;
  color-scheme: dark;
  display: flex;
  flex: 1;
  gap: 0.65rem;
  height: 3.15rem;
  min-height: 3.15rem;
  min-width: 0;
  overflow: hidden;
  padding: ${({ $compact }) => ($compact ? "0.45rem 0.75rem" : "0.45rem 0.75rem 0.45rem 0.45rem")};
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease;

  &:focus-within {
    border-color: var(--brand-highlight);
    box-shadow: var(--brand-input-focus-ring);
  }
`;

export const SchoolSelectorLogoSlot = styled.div`
  flex-shrink: 0;
  height: 2.25rem;
  overflow: hidden;
  width: 2.25rem;

  & > * {
    display: block;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
  }
`;

export const SchoolSelectorBrandLogo = styled.img`
  display: block;
  height: 100%;
  object-fit: contain;
  padding: 0.2rem;
  width: 100%;
`;

export const SchoolSelectorSelectWrap = styled.div`
  flex: 1;
  min-width: 0;

  .school-selector__control,
  .team-selector__control {
    height: 2.25rem;
    min-height: 2.25rem;
  }

  .school-selector__value-container,
  .team-selector__value-container {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .school-selector__single-value,
  .team-selector__single-value {
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    position: static;
    text-overflow: ellipsis;
    transform: none;
    white-space: nowrap;
  }

  .school-selector__placeholder,
  .team-selector__placeholder {
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    position: static;
    text-overflow: ellipsis;
    transform: none;
    white-space: nowrap;
  }

  @media (min-width: 640px) {
    min-width: 12rem;
  }
`;

export const SchoolSelectorOptionLabel = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 0.65rem;
  min-width: 0;
`;

export const SchoolSelectorOptionLogo = styled.span`
  flex-shrink: 0;
  height: 1.75rem;
  width: 1.75rem;
`;

export const SchoolSelectorEmptyMessage = styled.p`
  color: rgba(245, 239, 230, 0.72);
  font-size: 0.8125rem;
  line-height: 1.4;
  margin: 0;
`;
